import { getOrderId, getOrderingSystem, getSelectedOrder, getSelectedShop } from '../../selectors/tools';
import { getSimplrAccountIdOfSelectedTicket } from '../../extractFromState';
import { commonOrdersPostQuery } from '../../api/orders/shared';
import {
  PREVIOUS_REFUNDS_FULFILLED,
  PREVIOUS_REFUNDS_PENDING,
  PREVIOUS_REFUNDS_REJECTED,
} from '../../reducers/tools/decisionTree/previousRefunds';

export const previousRefundsPending = () => {
  return {
    type: PREVIOUS_REFUNDS_PENDING,
  };
};

export const previousRefundsFulfilled = (result) => {
  return {
    type: PREVIOUS_REFUNDS_FULFILLED,
    result,
  };
};

export const previousRefundsRejected = (error) => {
  return {
    type: PREVIOUS_REFUNDS_REJECTED,
    error,
  };
};

export const getPreviousRefunds = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const selectedOrder = getSelectedOrder(state);
    const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);
    const shopName = getSelectedShop(state);
    const shopType = getOrderingSystem(state);
    const orderId = getOrderId(selectedOrder, shopType).toString();

    const params = {
      simplrAccountId,
      orderId,
      shopName,
      shopType,
    };
    dispatch(previousRefundsPending());
    const response = await commonOrdersPostQuery('/refunds', {}, params);
    dispatch(previousRefundsFulfilled(response));
  } catch (e) {
    dispatch(previousRefundsRejected(e));
  }
};
